/**
 * useVisibleDashboards — return the subset of DASHBOARDS the current user
 * can access. Single source of truth shared by DashboardLauncher and the
 * header DashboardMenu so any future filter change (e.g. roles, tenants)
 * applies to both surfaces at once.
 */

import { DASHBOARDS, DashboardEntry } from '../config/dashboards';
import { usePermissions } from './usePermissions';

interface VisibleDashboards {
  loading: boolean;
  dashboards: DashboardEntry[];
}

export function useVisibleDashboards(): VisibleDashboards {
  const { loading, has } = usePermissions();
  const dashboards = DASHBOARDS.filter(
    (d) => !d.permission || has(d.permission),
  );
  return { loading, dashboards };
}
